import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About GENT 2025",
    date: "Sep 16th, 2025",
    organizer: "Helix Conferences",
    description: [
      <>
        The Global Summit on Graphene & Nanotechnology (GENT 2025) is a leading International platform dedicated to exploring transformative Research and emerging technologies in graphene science and Nanotech engineering. Recognized as part of the International Graphene Conclave, <Link to='https://helixconferences.com/blog.php' className="text-one" target="_blank"><strong>GENT 2025 </strong></Link> unites Global minds from academia, R&D, and industry to engage in dialogue, innovation, and discovery.
      </>,
      <>
        As one of the most awaited 2025 Graphene Conferences and a key contributor to the annual lineup of Global Nanotechnology Events, GENT 2025 offers high-impact knowledge-sharing opportunities through: Thematic tracks on 2D materials, nanoelectronics, and biomedical Nanotech. Industry-focused panels and case studies. Collaboration spaces for startups and investors. At the heart of 2025 Nanotechnology Summits, GENT 2025 promotes innovation that addresses Global challenges from clean energy and smart sensors to biocompatible materials and flexible electronics. Experience the power of Graphene. Explore the potential of NanoTech. Empower your Research and career only at GENT 2025.
      </>,
    ],
  },

  whyAttend: [
    "Discover breakthrough research and applications in graphene science and nanotechnology.",
    "Engage with leading scientists, engineers, and innovators shaping the future of nano-materials.",
    "Explore commercial strategies with investors and startups in emerging nanotech markets.",
    "Gain insights into industrial case studies and regulatory frameworks in nanotechnology.",
    "Be part of global conversations redefining sustainability, electronics, and biomedical engineering.",
  ],

  aboutHelix: [
    "Helix Conferences has earned international recognition for organizing high-impact events in emerging technologies. Our summits are built around innovation, research excellence, and global collaboration to empower communities and accelerate scientific progress.",
  ],

  whoShouldAttend: [
    "Materials scientists and nanotech researchers",
    "Engineers and graphene industry professionals",
    "Academic scholars and doctoral students",
    "Startups, investors, and innovation accelerators",
    "Policy-makers and technology regulators",
  ],

  join: [
    "Join us at GENT 2025 to explore the frontier of graphene and nanotechnology, where innovation meets impact. Shape tomorrow’s materials and global scientific collaboration.",
  ],

  themes: [
    {
      icon: Brain,
      title: "2D Materials",
      description:
        "Explore emerging advances in graphene and related 2D materials.",
    },
    {
      icon: HeartPulse,
      title: "Nanoelectronics",
      description: "Device miniaturization, sensors, and electronic systems at the nanoscale.",
    },
    {
      icon: SmilePlus,
      title: "Biomedical Nanotech",
      description:
        "Nanotechnology in drug delivery, diagnostics, and tissue engineering.",
    },
    {
      icon: Dna,
      title: "Nanofabrication",
      description:
        "Innovative techniques for nanoscale material design and assembly.",
    },
    {
      icon: Video,
      title: "Nano Regulatory Affairs",
      description:
        "Frameworks and standards for safety, compliance, and policy in nanotechnology.",
    },
    {
      icon: Globe,
      title: "Sustainable Nanotech",
      description:
        "Green nanomaterials for clean energy, water, and environmental solutions.",
    },
    {
      icon: Biohazard,
      title: "Graphene Chemistry",
      description:
        "Understanding the chemical behavior and synthesis of graphene compounds.",
    },
    {
      icon: Radiation,
      title: "Nanocharacterization",
      description:
        "Advanced tools for analyzing the properties of nanomaterials.",
    },
  ],

  highlights: [
    {
      title: "Keynote Speakers",
      description: "Renowned researchers and technologists in nanoscience",
    },
    {
      title: "Panel Discussions",
      description: "Strategic talks on innovation, ethics, and industry trends",
    },
    {
      title: "Live Demonstrations",
      description: "Interactive showcases of nano-enabled tools and applications",
    },
    {
      title: "Innovation Labs",
      description: "Hands-on exploration of nanoscale fabrication techniques",
    },
    {
      title: "Poster Presentations",
      description: "Latest academic research from global institutions",
    },
    {
      title: "Workshops",
      description: "Skill-building sessions on emerging graphene technologies",
    },
    {
      title: "Partnership Zones",
      description: "Networking opportunities for collaboration and investment",
    },
    {
      title: "Awards & Recognition",
      description: "Celebrating excellence in nano research and innovation",
    },
  ],

  dates: {
    eventDate: "16th Sep 2025",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "1st Sep 2025",
  },
};



const AboutPublicHealth = () => {
  return (
    <div className="w-full 2xl:max-w-[1280px] mx-auto justify-center items-center text-center">
      <div className={`${banner_style} w-full mx-auto about-banner`}>
        <h1 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h1>
      </div>

      <h1 className="text-4xl mt-2 font-bold text-one">
        A CONFERENCE ON GENT-2025
      </h1>
      <p className="text-center text-gray-600 text-3xl mb-6">
        <strong>
          Sep 16th, 2025
        </strong>
      </p>

      {data.event.description.map((desc, idx) => (
        <p
          key={idx}
          className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
        >
          {desc}
        </p>
      ))}

      {/* Why Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Why Attend the 2025 Oral Medicine Conference?</h2>
        {data.whyAttend.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* About Helix Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Helix Conferences: Leading the Way in Event Organization</h2>
        {data.aboutHelix.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* Who Should Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Who Can Attend?</h2>
        <ul className="list-disc list-inside text-base text-gray-700 text-center w-full">
          {data.whoShouldAttend.map((item, idx) => (
            <li key={idx} className="mb-2">{item}</li>
          ))}
        </ul>
      </section> */}

      {/* Join Section */}
      <section className="mb-10 text-center w-full min-w-4xl px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at GENT Conference 2025
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              GENT Professionals
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Academics & Researchers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Stethoscope className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare Administrators
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare product and Service providers
            </h3>
          </div>
          {/* <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <GraduationCap className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Students and trainees in dentistry and related fields</h3>
          </div> */}
        </div>
      </section>

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm "
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;

